import React from "react";

import aboutImage from "../assets/about-image.jpg"
import "./About.css";
import "aos/dist/aos.css";
import AOS from "aos";

const About = () => {
  React.useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    
<div className="about-section" >
  <h2 className="section-title" data-aos="fade-right">About LEPIC</h2>
  <p className="tagline" data-aos="fade-left">Innovate. Learn. Grow.</p>

  <div className="image-container">
    <img src={aboutImage} alt="LEPIC visual" className="about-image" />
  </div>

  <p className="about-description" data-aos="fade-up">
    LEPIC is a vibrant hub of learning and innovation that encourages young minds...
    LEPIC (Learner's Pick) is a dedicated YouTube platform that empowers B.Tech students by
              offering high-quality video content covering semester-wise subjects, one-shot revisions,
              solved PYQs, AKTU syllabus guides, and digital study notes. Our mission is to simplify 
              complex concepts and help you prepare smarter, not harder.
  </p>

  <div className="key-metrics" data-aos="fade-down">
    <div className="metric-box">
      <h3>3000+ Students</h3>
      <p>Engaged in active learning and innovation activities</p>
    </div>
    
    <div className="metric-box">
                <h3>🎓 B.Tech Resources</h3>
                <p>Complete academic coverage, 1st to 4th year.</p>
              </div>
              <div className="metric-box">
                <h3>📚 Smart Notes</h3>
                <p>Topic-wise, downloadable and easy-to-follow notes.</p>
              </div>
              <div className="metric-box">
                <h3>📺 Simplified Videos</h3>
                <p>PYQs, One-shots, full syllabus explained visually.</p>
              </div>
              <div className="metric-box">
  <h3>Trusted by  Students</h3>
  <p>Across India, learners rely on LEPIC for clear, effective, and exam-focused content.</p>
</div>
<div className="metric-box">
  <h3>Deep Concept Coverage</h3>
  <p>Each topic is explained thoroughly with real-life analogies and step-by-step logic.</p>
</div>

  </div>

  {/* <button className="learn-more-btn">Learn More</button> */}
</div>

  );
};

export default About;


